import React, { useContext } from 'react';
import Select from 'react-select';
import { AgendaContext } from '../context/AgendaContext';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
    position: relative; 
    z-index: 1001; 
`

const SelectCommittee = ({ setError }) => {
    const { 
        committeeList, committeeName, setCommitteeName,
    } = useContext(AgendaContext);
    const { t } = useTranslation(); 

    const committeeOptions = Array.isArray(committeeList)
        ? committeeList.map(list => ({
            label: `${list.name} - ${list.title}`,
            value: list.name,
            title: list.title, 
            id: list.id
        }))
        : []; 

    const styledCommitteeOptions = {
        control: (provided, state) => ({
            ...provided,
            cursor: 'pointer',
            width: '100%',
            borderRadius: '4px',
            borderColor: state.isFocused ? '#00A0D8' : '#D8D8D8',
            backgroundColor: '#fff',
            '&:hover': {
              borderColor: '#00A0D8', 
            }, 
        }),
        option: (provided, state) => ({
            ...provided,
            cursor: 'pointer',
            backgroundColor: 
                state.isSelected 
                    ? '#0091C6'
                    :  state.isFocused 
                        ? '#fff'
                        : '#fff', 
            color: 
                state.isSelected
                    ? '#fff'
                    : state.isFocused 
                        ? '#000'
                        : '#000', 
            '&:hover': {
                backgroundColor: '#66C6EC', 
                color: '#fff', 
            }
        }), 
        dropdownIndicator: (provided, state) => ({
            ...provided,
            color: 
            state.isSelected
                ? '#777777'
                : state.isFocused 
                    ? '#777777'
                    : '#D8D8D8', 
            '&:hover': {
                color: '#777777', 
            }
        }),
        clearIndicator: (provided, state) => ({
            ...provided,
            color: 
            state.isSelected
                ? '#777777'
                : state.isFocused 
                    ? '#777777'
                    : '#D8D8D8', 
            '&:hover': {
                color: '#777777', 
            }
        }),
    };  

    const handleChange = (selectedOption) => {
        setCommitteeName(selectedOption);

        if (selectedOption !== null ) {
            setError(prevError => ({...prevError, committeeName: ''}))
        }
    }

    return (
        <Wrapper>
            <Select
                options={committeeOptions}
                value={committeeName}
                onChange={handleChange}
                styles={styledCommitteeOptions}
                placeholder={t('committeeSelection.selectCommittee')}
                isClearable
            />
        </Wrapper>
    );
};

export default SelectCommittee;